import { useParams, useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import Card from '../../components/Card';
import Button from '../../components/Button';

export default function ReportDetail() {
    const { reportId } = useParams();
    const navigate = useNavigate();

    return (
        <div className="space-y-6">
            <div className="flex items-center gap-4">
                <Button variant="secondary" onClick={() => navigate('/reports')}>
                    <ArrowLeft size={20} />
                </Button>
                <div>
                    <h1 className="text-3xl font-bold">Report Details</h1>
                    <p className="text-muted-light dark:text-muted-dark">
                        Review and take action on this report
                    </p>
                </div>
            </div>

            <Card>
                <p className="text-muted-light dark:text-muted-dark">
                    Report details for ID: {reportId}
                </p>
            </Card>
        </div>
    );
}

